/**
 * Class básico del componente
 */
export const classNameCommon = 'c-ctn-card';
export const classNameTemplate = 'c-ctn-card__template';
export const classNameCharts = 't-ctn-card-chart';
